// extracted by mini-css-extract-plugin
export default {"link":"MaterialsMorePopover_link__rm4CQ","button":"MaterialsMorePopover_button__El4Z3"};